import { render } from "./StatusButton.vue?vue&type=template&id=39be14f6&scoped=true"
import script from "./StatusButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusButton.vue?vue&type=script&setup=true&lang=js"

import "./StatusButton.vue?vue&type=style&index=0&id=39be14f6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39be14f6"],['__file',"resources/js/modules/labelinsight-products/components/StatusButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39be14f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39be14f6', __exports__)) {
    api.reload('39be14f6', __exports__)
  }
  
  module.hot.accept("./StatusButton.vue?vue&type=template&id=39be14f6&scoped=true", () => {
    api.rerender('39be14f6', render)
  })

}


export default __exports__